import { handleActions } from 'redux-actions';
import * as Actions from '../actions/mentorAssignActions';

const app = handleActions({
  [Actions.setInitialTeamOpen]: (state, action) => ({
    ...state,
    teamOpens: {
      ...state.teamOpens,
      [action.payload]: false,
    },
  }),
  [Actions.toggleTeamOpen]: (state, action) => ({
    ...state,
    teamOpens: {
      ...state.teamOpens,
      [action.payload]: !state.teamOpens[action.payload],
    },
  }),
  [Actions.openAllTeams]: (state) => {
    const teamOpens = {};
    Object.keys(state.teamOpens).forEach((key) => {
      teamOpens[key] = true;
    });
    return {
      ...state,
      teamOpens,
    };
  },
}, {
  teamOpens: {},
});

export default app;
